import React, { useContext, useEffect, useRef, useState } from "react";
import style from "./Message.module.css";
import { Authcontext } from "../context/Authcontext";
import { Link } from "react-router-dom";
import { IoFileTrayStackedSharp } from "react-icons/io5";
import { PiFilePdfBold } from "react-icons/pi";
import Overlayform from "../admin/Overlay";
import AudioPlayer from "../AudioPlayer/AudioPlayer";
import { FileIcon, defaultStyles } from "react-file-icon";
import { Input, Modal } from "antd";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/config";

const Message = (props) => {
  const { currentuser } = useContext(Authcontext);
  const [icon, setIcon] = useState("dmg");
  const ref = useRef();
  const [editedMessage, setEditedMessage] = useState(null);
  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [props.message]);
  function extractFileExtension(url) {
    // Check if the URL is provided and is a string
    if (!url || typeof url !== "string") {
      return "Invalid URL";
    }

    try {
      // Create a new URL object with the provided URL
      const urlObj = new URL(url);
      // Get the pathname of the URL, which includes the filename
      const pathname = urlObj.pathname;
      // Split the pathname by '/' to extract the filename
      const parts = pathname.split("/");
      // Get the last part which contains the filename
      const fileName = parts[parts.length - 1].replace(/%20/g, " ");

      // Split the filename by '.' to get parts
      const nameParts = fileName.split(".");

      // Check if there is more than one part (i.e., there is an extension)
      if (nameParts.length > 1) {
        // Return the last part as the extension
        setIcon(nameParts.pop());
        return nameParts.pop();
      } else {
        return "No extension found";
      }
    } catch (error) {
      console.error("Invalid URL provided:", error);
      return "Invalid URL";
    }
  }
  useEffect(() => {
    if (props?.message?.file) {
      extractFileExtension(props?.message?.file);
    }
  }, [props?.message?.file]);
  function extractFileName(url) {
    // Check if the URL is provided
    if (!url) {
      return "File name not found";
    }

    // Create a new URL object with the provided URL
    const urlObj = new URL(url);
    // Get the pathname of the URL, which includes the filename
    const pathname = urlObj?.pathname;
    // Split the pathname by '/' to extract the filename
    const parts = pathname?.split("/");
    // Get the last part which contains the filename
    const fileName = parts[parts?.length - 1];
    return fileName?.replace(/%20/g, " ");
  }
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    updateMessageText(props?.message, editedMessage);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  async function updateMessageText(message, newText) {
    try {
      // Retrieve the document from the "messages" collection
      const docRef = doc(db, "messages", message.chatid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        // Get the list of messages
        let messagesList = docSnap.data().message;

        // Find the index of the message to update
        const index = messagesList.findIndex((msg) => msg.id === message.id);

        if (index !== -1) {
          // Update the text of the message
          messagesList[index].text = newText;

          // Update the document in Firestore with the modified messages list
          await updateDoc(docRef, { message: messagesList });
          console.log("Message updated successfully!");
        } else {
          console.log("Message not found!");
        }
      } else {
        console.log("No such document!");
      }
    } catch (error) {
      console.error("Error updating document: ", error);
    }
  }
  if (props.message.status === "approved") {
    return (
      <>
        <Modal
          title="Basic Modal"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}>
          <Input
            defaultValue={props.message.text}
            onChange={(e) => {
              setEditedMessage(e?.target?.value);
            }}
          />
        </Modal>
        <div
          className={`${style.everymessage} ${
            props.message.senderid !== currentuser.uid && style.owner
          }`}>
          <div className={style.messageinfo}>
            <img
              src={
                props.message.senderid === currentuser.uid
                  ? currentuser.photoURL
                  : props.message.senderimage
              }
              alt="sender picture"
            />
          </div>
          <div
            className={`${style.content} ${
              props.message.senderid === currentuser.uid && style.contentowner
            }`}
            ref={ref}>
            {props.message.text && (
              <p
                style={{ color: props.color }}
                onClick={() => {
                  setIsModalOpen(true);
                }}>
                <span style={{ color: "#D3A61E" }}>
                  {props.message.sendername}
                </span>
                <br />
                {props.message.text}
              </p>
            )}
            {props.message.type === "image" ? (
              <>
                <span style={{ color: "#D3A61E" }}>
                  {props.message.sendername}
                </span>
                <br />
                <Link
                  target="_blank"
                  to={props.message.file}
                  style={{ textAlign: "left" }}>
                  <img src={props.message.file} alt="picture message" />
                </Link>
              </>
            ) : null}
            {props.message.type === "video" ? (
              <>
                <span style={{ color: "#D3A61E" }}>
                  {props.message.sendername}
                </span>
                <br />
                <Link
                  target="_blank"
                  to={props.message.file}
                  style={{ textAlign: "left" }}>
                  <video width="500px" height="300px" controls>
                    <source src={props.message.file} type="video/mp4" />
                  </video>
                </Link>
              </>
            ) : null}
            {props.message.type === "record" ? (
              <>
                {!props.message.text && (
                  <span style={{ color: "#D3A61E", margin: "15px 0" }}>
                    {props.message.sendername}
                  </span>
                )}
                <AudioPlayer audioUrl={props?.message?.file} />
              </>
            ) : null}
            {props.message.type !== "image" &&
            props.message.type !== "video" &&
            props.message.type !== "text" &&
            props.message.type !== "record" ? (
              <>
                {!props.message.text && (
                  <span style={{ color: "#D3A61E" }}>
                    {props.message.sendername}
                  </span>
                )}
                {/* <br /> */}
                <Link
                  target="_blank"
                  to={props.message.file}
                  style={{ textAlign: "left", margin: "auto" }}>
                  {/* <IoFileTrayStackedSharp color="black" size={60} /> */}
                  <div
                    style={{
                      width: "60px",
                      height: "60px",
                      margin: "10px auto",
                      textAlign: "center",
                    }}>
                    <FileIcon
                      extension={icon}
                      {...{ ...defaultStyles[icon], ...defaultStyles.docx }}
                    />
                  </div>
                </Link>
                {/* <br /> */}
                <p
                  style={{
                    backgroundColor: "transparent",
                    margin: "10px 0px",
                  }}>
                  {extractFileName(props.message.file)}
                </p>
              </>
            ) : null}
          </div>
        </div>
      </>
    );
  } else if (
    props.message.status === "pending" &&
    props.message.senderid === currentuser.uid
  ) {
    return (
      <>
        <Modal
          title="Basic Modal"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}>
          <Input
            defaultValue={props.message.text}
            onChange={(e) => {
              setEditedMessage(e?.target?.value);
            }}
          />
        </Modal>
        <div
          className={`${style.everymessage} ${
            props.message.senderid !== currentuser.uid && style.owner
          }`}>
          <div className={style.messageinfo}>
            <img
              src={
                props.message.senderid === currentuser.uid
                  ? currentuser.photoURL
                  : props.message.senderimage
              }
              alt="sender picture"
            />
          </div>
          <div
            className={`${style.content} ${
              props.message.senderid === currentuser.uid && style.contentowner
            }`}
            ref={ref}>
            {props.message.text && (
              <p
                style={{ color: props.color }}
                onClick={() => {
                  setIsModalOpen(true);
                }}>
                <span style={{ color: "#D3A61E" }}>
                  {props.message.sendername}
                </span>
                <br />
                {props.message.text}
              </p>
            )}
            {props.message.type === "image" ? (
              <>
                <span style={{ color: "#D3A61E" }}>
                  {props.message.sendername}
                </span>
                <br />
                <Link
                  target="_blank"
                  to={props.message.file}
                  style={{ textAlign: "left" }}>
                  <img src={props.message.file} alt="picture message" />
                </Link>
                <span>ف انتظار موافقه المدير</span>
              </>
            ) : null}
            {props.message.type === "video" ? (
              <>
                <span style={{ color: "#D3A61E" }}>
                  {props.message.sendername}
                </span>
                <br />
                <Link
                  target="_blank"
                  to={props.message.file}
                  style={{ textAlign: "left" }}>
                  <video width="500px" height="300px" controls>
                    <source src={props.message.file} type="video/mp4" />
                  </video>
                </Link>
                <span>ف انتظار موافقه المدير</span>
              </>
            ) : null}
            {props.message.type !== "image" &&
            props.message.type !== "video" &&
            props.message.type !== "text" ? (
              <>
                {!props.message.text && (
                  <span style={{ color: "#D3A61E" }}>
                    {props.message.sendername}
                  </span>
                )}
                {/* <br /> */}
                <Link
                  target="_blank"
                  to={props.message.file}
                  style={{ textAlign: "left", margin: "auto" }}>
                  {/* <IoFileTrayStackedSharp color="black" size={60} /> */}
                  <div
                    style={{
                      width: "60px",
                      height: "60px",
                      margin: "10px auto",
                      textAlign: "center",
                    }}>
                    <FileIcon
                      extension={icon}
                      {...{ ...defaultStyles[icon], ...defaultStyles.docx }}
                    />
                  </div>
                </Link>
                {/* <br /> */}
                <p
                  style={{
                    backgroundColor: "transparent",
                    margin: "10px 0px",
                  }}>
                  {extractFileName(props.message.file)}
                </p>
              </>
            ) : null}
          </div>
        </div>
      </>
    );
  } else if (
    props.message.status === "reject" &&
    props.message.senderid === currentuser.uid
  ) {
    return (
      <>
        <Modal
          title="Basic Modal"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}>
          <Input
            defaultValue={props.message.text}
            onChange={(e) => {
              setEditedMessage(e?.target?.value);
            }}
          />
        </Modal>
        <div
          className={`${style.everymessage} ${
            props.message.senderid !== currentuser.uid && style.owner
          }`}>
          <div className={style.messageinfo}>
            <img
              src={
                props.message.senderid === currentuser.uid
                  ? currentuser.photoURL
                  : props.message.senderimage
              }
              alt="sender picture"
            />
          </div>
          <div
            className={`${style.content} ${
              props.message.senderid === currentuser.uid && style.contentowner
            }`}
            ref={ref}>
            {props.message.text && (
              <p
                style={{ color: props.color }}
                onClick={() => {
                  setIsModalOpen(true);
                }}>
                <span style={{ color: "#D3A61E" }}>
                  {props.message.sendername}
                </span>
                <br />
                {props.message.text}
              </p>
            )}
            {props.message.type === "image" ? (
              <>
                <span style={{ color: "#D3A61E" }}>
                  {props.message.sendername}
                </span>
                <br />
                <Link
                  target="_blank"
                  to={props.message.file}
                  style={{ textAlign: "left" }}>
                  <img src={props.message.file} alt="picture message" />
                </Link>{" "}
                <span>تم رفض ارسال الرساله</span>
              </>
            ) : null}
            {props.message.type === "video" ? (
              <>
                <span style={{ color: "#D3A61E" }}>
                  {props.message.sendername}
                </span>
                <br />
                <Link
                  target="_blank"
                  to={props.message.file}
                  style={{ textAlign: "left" }}>
                  <video width="500px" height="300px" controls>
                    <source src={props.message.file} type="video/mp4" />
                  </video>
                </Link>
                <span>تم رفض ارسال الرساله</span>
              </>
            ) : null}
            {props.message.type !== "image" &&
            props.message.type !== "video" &&
            props.message.type !== "text" ? (
              <>
                {!props.message.text && (
                  <span style={{ color: "#D3A61E" }}>
                    {props.message.sendername}
                  </span>
                )}
                {/* <br /> */}
                <Link
                  target="_blank"
                  to={props.message.file}
                  style={{ textAlign: "left", margin: "auto" }}>
                  {/* <IoFileTrayStackedSharp color="black" size={60} /> */}
                  <div
                    style={{
                      width: "60px",
                      height: "60px",
                      margin: "10px auto",
                      textAlign: "center",
                    }}>
                    <FileIcon
                      extension={icon}
                      {...{ ...defaultStyles[icon], ...defaultStyles.docx }}
                    />
                  </div>
                </Link>
                {/* <br /> */}
                <p
                  style={{
                    backgroundColor: "transparent",
                    margin: "10px 0px",
                  }}>
                  {extractFileName(props.message.file)}
                </p>
              </>
            ) : null}
          </div>
        </div>
      </>
    );
  } else {
    return null;
  }
};
export default Message;
